import {Routes} from '@angular/router';

// The base route for the damage category management
export const DAMAGE_CATEGORY_BASE_ROUTE = 'damage-categories';

// The routes for the damage category management
export const DAMAGE_CATEGORY_ROUTES: Routes = [
    /// LIST of Damage Categories
    {
        path: '',
        loadComponent: () =>
            import('src/packages/damage-reporting/features/damage-category-list/damage-category-list.page.component'),
    },
    /// CREATE Damage Category
    {
        path: 'details/create',
        loadComponent: () =>
            import('src/packages/damage-reporting/features/damage-category-create-update/damage-category-create-update.page.component'),
    },
    /// UPDATE Damage Category
    {
        path: 'details/:id',
        loadComponent: () =>
            import('src/packages/damage-reporting/features/damage-category-create-update/damage-category-create-update.page.component'),
    },
];